export default "__VITE_ASSET__Vdi$MRi___"